export default __webpack_public_path__ + "static/media/455.fbcf6eae.gif";